import UserList from '../components/users/UserList';
import UserSearch from '../components/users/UserSearch';

const Home = () => {
  return (
    <>
      <UserSearch />
      <UserList />
    </>
  );
};

export default Home;
